export const ENTITIES_LIST_REQUEST = 'ENTITIES_LIST_REQUEST';
export const ENTITIES_LIST_SUCCESS = 'ENTITIES_LIST_SUCCESS';
export const ENTITIES_LIST_FAILURE = 'ENTITIES_LIST_FAILURE';

export const SELECT_ENTITY = 'SELECT_ENTITY';
export const REMOVE_ENTITY = 'REMOVE_ENTITY';
export const REMOVE_ALL_ENTITIES = 'REMOVE_ALL_ENTITIES';
export const ADD_SELECTED_ENTITIES = 'ADD_SELECTED_ENTITIES';

export const CREATE_ENTITY_REQUEST = 'CREATE_ENTITY_REQUEST';
export const CREATE_ENTITY_SUCCESS = 'CREATE_ENTITY_SUCCESS';
export const CREATE_ENTITY_FAILURE = 'CREATE_ENTITY_FAILURE';

export const RESET_MODIFIED_ENTITY = 'RESET_MODIFIED_ENTITY';
export const MODIFY_ENTITY_REQUEST = 'MODIFY_ENTITY_REQUEST';
export const MODIFY_ENTITY_SUCCESS = 'MODIFY_ENTITY_SUCCESS';
export const MODIFY_ENTITY_FAILURE = 'MODIFY_ENTITY_FAILURE';

export const DELETE_ENTITY_REQUEST = 'DELETE_ENTITY_REQUEST';
export const DELETE_ENTITY_SUCCESS = 'DELETE_ENTITY_SUCCESS';
export const DELETE_ENTITY_FAILURE = 'DELETE_ENTITY_FAILURE';
